import { useEffect, useRef, useState } from 'react';
export const SLOT_UNAVAILABLE_REASON = 'SLOT_UNAVAILABLE';
const isSlotUnavailable = (error)=>error?.params?.reason === SLOT_UNAVAILABLE_REASON;
/** Start dates of slots the server rejected as taken, for the picker to drop. */ export const useSlotRejection = ({ error, selectedSlot })=>{
    const [rejectedSlotStartDates, setRejectedSlotStartDates] = useState([]);
    const isRejected = isSlotUnavailable(error);
    const startDate = selectedSlot?.startDate;
    // The error stays on the field until revalidation drops it, so latch one rejection to one
    // slot — otherwise a slot picked while it is still up gets rejected too.
    const hasHandledRejection = useRef(false);
    useEffect(()=>{
        if (!isRejected) {
            hasHandledRejection.current = false;
            return;
        }
        if (hasHandledRejection.current) {
            return;
        }
        hasHandledRejection.current = true;
        if (!startDate) {
            return;
        }
        setRejectedSlotStartDates((rejected)=>rejected.includes(startDate) ? rejected : [
                ...rejected,
                startDate
            ]);
    }, [
        isRejected,
        startDate
    ]);
    return rejectedSlotStartDates;
};

//# sourceMappingURL=use-slot-rejection.js.map